/**
 * Analyst consensus generation constants (plan §3.3 · F15).
 * Verdict thresholds live in @meridian/contracts VERDICT_THRESHOLDS.
 */

/** nA = ANALYST_BASE + floor(R() * ANALYST_SPAN). */
export const ANALYST_BASE = 22;
export const ANALYST_SPAN = 26;

/** buy = round(nA * (BUY_RATIO_LO + R() * BUY_RATIO_SPAN)). */
export const BUY_RATIO_LO = 0.3;
export const BUY_RATIO_SPAN = 0.5;

/** hold = round((nA - buy) * (HOLD_RATIO_LO + R() * HOLD_RATIO_SPAN)). */
export const HOLD_RATIO_LO = 0.4;
export const HOLD_RATIO_SPAN = 0.5;

/** target = price * (1 + (buy/nA - TARGET_BIAS) * TARGET_SCALE + TARGET_PAD). */
export const TARGET_BIAS = 0.35;
export const TARGET_SCALE = 0.5;
export const TARGET_PAD = 0.04;
